export default __webpack_public_path__ + "static/sentrydefault_480x270-75649e015add7c8ae1cd6de72b36742f.jpg";